/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR_SPACE = 'password_contains_space';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_NUMBERS_OR_SPECIAL_CHARACTER = 'password_needs_number_or_special_character';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_SMALL_LETTERS = 'password_needs_small_letter';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_CAPITAL_LETTERS = 'password_needs_capital_letter';
/**
 * Creates validator for password
 *
 * @function password
 * @return {validator} password validator
 */

export default function password() {
  return function (value) {
    if (value && /\s/i.test(value)) return ERROR_SPACE;
    if (value && !/[a-z]+/.test(value)) return ERROR_SMALL_LETTERS;
    if (value && !/[A-Z]+/.test(value)) return ERROR_CAPITAL_LETTERS;
    if (value && !/[0-9]+/.test(value)) {
      if (!/[^a-zA-Z]+/.test(value)) return ERROR_NUMBERS_OR_SPECIAL_CHARACTER;
    }
    return null;
  };
}